<div class="close-button" (click)="closeDialog()"></div>
<div class="scrollable">
  <div class="top-info">
    <ng-template [ngIf]="isPledge">
      <div class="congrat">{{ "VOTE_CONFIRMATION.congrats_voteconfirmation" | translate }}</div>
      <div class="message-lg">
        <ng-template [ngIf]="isPledge">
          <ng-template [ngIf]="hasSubs">
            {{ "VOTE_CONFIRMATION.support_voteconfirmation" | translate }} {{companyName}} {{ "VOTE_CONFIRMATION.support2_voteconfirmation" | translate }}
          </ng-template>
          <ng-template [ngIf]="!hasSubs">
            {{ "VOTE_CONFIRMATION.supported_voteconfirmation" | translate }} {{companyName}}.
          </ng-template>
        </ng-template>
        <ng-template [ngIf]="!isPledge">
          {{ "VOTE_CONFIRMATION.subtitle1_public_voteconfirmation" | translate }}
        </ng-template>
      </div>
      <div class="share" *ngIf="!isPledge" appTooltip></div>
      <div class="message-sm change">{{ "VOTE_CONFIRMATION.change_voteconfirmation" | translate }}</div>
      <div class="votes-left" *ngIf="isPledge">
        <span class="votes-icon-container">
          <span class="vote-icon" *ngFor="let i of [].constructor(votesLeft)">
            <span class="icon supported"></span>
          </span>
        </span>
        <span class="votes-text">{{ "VOTE_CONFIRMATION.have_voteconfirmation" | translate }} <span>{{votesLeft}}</span> {{ "VOTE_CONFIRMATION.remaining_voteconfirmation" | translate }}</span>
      </div>
      <button class="yellow serif" (click)="closeDialog()" [routerLink]="[currentLang, RouterUrls.BrowseProjects]" *ngIf="isPledge">
        {{ "VOTE_CONFIRMATION.browse_voteconfirmation" | translate }}
      </button>
    </ng-template>
    <ng-template [ngIf]="!isPledge">
      <div class="logo">
        <img loading="lazy" src="/assets/icons/colibri-dark-blue.svg" alt="bird">
      </div>
      <div class="title">{{ "VOTE_CONFIRMATION.great_voteconfirmation" | translate }}</div>
      <div class="message-lg">
          {{ "VOTE_CONFIRMATION.subscription_voteconfirmation" | translate }}
      </div>
      <div class="share public" appTooltip></div>
    </ng-template>
  </div>
  <div class="bottom-info">
    <div class="more-impact">{{ "VOTE_CONFIRMATION.onetime_title_voteconfirmation" | translate }}</div>
    <div class="buttons-container">
      <ng-template [ngIf]="hasSubs">
        <button class="green serif with-bird one-time-donation" (click)="openOneTimeDonation()">
          <span class="bird-one-time"><img loading="lazy" src="/assets/icons/colibri-one-time.svg" alt="bird"></span>
          <span>{{ "VOTE_CONFIRMATION.extra_voteconfirmation" | translate }}</span>
        </button>
      </ng-template>
      <ng-template [ngIf]="!hasSubs">
        <button class="green serif with-bird one-time-donation" (click)="openOneTimeDonation()">
          <span class="bird"><img loading="lazy" src="/assets/icons/colibri-very-dark-grey.svg" alt="bird"></span>
          <span>{{ "VOTE_CONFIRMATION.donate_voteconfirmation" | translate }}</span>
        </button>
      </ng-template>
    </div>
  </div>
</div>


